module.exports = __webpack_public_path__ + "static/media/c361e26e-4526-46d8-a9f6-c74877ea3bce.82d01b02.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/c361e26e-4526-46d8-a9f6-c74877ea3bce.woff2
// module id = 74
// module chunks = 0